import { useEffect, FC } from "react";
import Table from "./components/Table";

const InsuranceSelect: FC<{
  bundleData: any;
  modalToggleHandler: any;
}> = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container collect insurance">
      <div className="collect__section">
        <h2 className="heading--secondary collect__heading">
          Choose an insurance package
        </h2>
        <p className="text--primary collect__text">
          Select an insurance package from the offers below
        </p>
        <Table
          packages={props.bundleData}
          modalToggleHandler={props.modalToggleHandler}
        />
      </div>
    </div>
  );
};

export default InsuranceSelect;
